// my-functions
const removeFeaturedProducts = function () {
	// 移除精選分類
	$('.ProductList-categoryMenu > li > a.Label').filter(function () {
		// .text() 取得文字, .trim() 去除前後空白
		return $(this).text().trim() === '精選商品';
	}).parent('li').hide();
	// ============
}

// google翻譯腳本，要用原生JS
function googleTranslateElementInit() {
	new google.translate.TranslateElement({
		pageLanguage: 'zh-TW', // 網站原始語言
		includedLanguages: 'zh-TW,en', // 開放翻譯的語言
		layout: google.translate.TranslateElement.InlineLayout.VERTICAL,
		autoDisplay: false
	}, 'google_translate_element');

	fixGoogleTranslateBodyStyles()
}

function goTranslate(lang) {
	$('.goog-te-combo').val(lang);

	const triggerEvent = (element, eventName) => {
		const event = new Event(eventName);
		element.dispatchEvent(event);
	};
	triggerEvent(document.querySelector('.goog-te-combo'), 'change');
}

// 狀態維持 (修正：確保非同步檢查時讀取到最新狀態)
const maintainLanguageState = function () {
	// 第一階段：立即執行
	const langNow = getCurrentTranslateLang();
	updateToggleButtonText(langNow);
	forceSetGoogleCookie(langNow);

	// 第二階段：延遲檢查 (防止 Google 腳本載入較慢覆蓋設定)
	setTimeout(() => {
		// [關鍵] 這裡必須重新呼叫 getCurrentTranslateLang() 取得最新狀態
		const freshLang = getCurrentTranslateLang();

		const $combo = $('.goog-te-combo');
		// 同步下拉選單的值
		if ($combo.length && freshLang === 'en' && $combo.val() !== 'en') {
			$combo.val('en');
		}

		// 再次強制更新 UI
		updateToggleButtonText(freshLang);
	}, 500);

	// 第三階段：雙重保險
	setTimeout(() => {
		updateToggleButtonText(getCurrentTranslateLang());
	}, 1500);
};


function fixGoogleTranslateBodyStyles() {
	// 監聽並移除 Google 翻譯對 body 施加的有害樣式
	// 使用 setTimeout 確保在 Google 翻譯腳本執行完畢後再執行
	setTimeout(function () {
		// 移除 Google 翻譯添加的 position: relative
		$('body').css({    // 清空樣式
			'position': '',
			'top': '',
			'left': '',
			'right': '',
			'width': ''
		});

	}, 500); // 0.5秒緩衝，等待 Google 腳本完成
}
// 清除nav下拉選單樣式
function changeNavDropdown(item) {
	const $targetElement = item;

	if ($targetElement.length) {
		$targetElement.css('right', '')
	} else {
		console.warn('找不到目標元素，請檢查選擇器。');
	}
}
// google 翻譯同步器
function syncGoogleTranslateLanguage() {
	// 1. 取得 Cookie 紀錄的目標語言
	const targetLang = getCurrentTranslateLang(); // e.g., 'en' 或 'zh-TW'
	if (!targetLang) return;

	// 2. 找到 Google 翻譯的「原生控制選單」
	// 這個元素位於你的主網域 DOM 中，所以沒有跨域問題
	const $combo = $('.goog-te-combo');

	// 如果 Google 腳本還沒載入完成，就跳過
	if (!$combo.length) return;

	// 檢查狀態是否不一致
	// 注意：Google 的 select value 通常是 'en', 'zh-TW', 'ja' 等 ISO 代碼
	const currentVal = $combo.val();

	// 如果目前選單的值，跟我們 Cookie 想要的不一樣，才進行強制更新
	if (currentVal !== targetLang) {

		$combo.val(targetLang);

		// 觸發原生 Change 事件
		// 使用原生 JS 的 dispatchEvent 是最穩的
		const element = $combo[0];
		const event = new Event('change', { bubbles: true, cancelable: true });
		element.dispatchEvent(event);

		updateToggleButtonText(targetLang);

		console.log('Language synced to:', targetLang);
	}
}

// my-functions end ==========

// ===============


window.onload = function () {
	$("#preload").fadeOut(300);

	// 全站通用

	// 路徑綁定
	const pathname = window.location.pathname; // 範例: /pages/products
	const search = window.location.search;     // 範例: ?query=123
	// ===========

	// more按鈕
	const $customMoreBtn = `
				<div class="customized-btn more-btn">Discover</div>
			`;
	const $customLearnMoreBtn = `
				<div class="customized-btn news-list-btn"><img src="https://gdlinode.tw/kapla/images/arrow-solid-default.svg" alt="arrow-default"></div>
			`;
	// more按鈕 end ==========

	// 監聽視窗
	const viewState = {
		isLaptop: false, // > 600px
		isDesktop: false    // > 1199px 
		// 未來可以無限新增...
	};
	// 監視器物件
	const mediaQueries = {
		isLaptop: window.matchMedia('(min-width: 601px)'),
		isDesktop: window.matchMedia('(min-width: 1200px)')
	};
	// (stateKey 會是 'isLaptop' 或 'isDesktop')
	function handleBreakpointChange(event, stateKey) {
		viewState[stateKey] = event.matches;
	}
	Object.keys(mediaQueries).forEach(function (key) {

		// 'key' 依序是 'isLaptop', 'isDesktop'
		const query = mediaQueries[key]; // 取得對應的監視器

		// (A) 立即檢查一次，設定初始狀態
		viewState[key] = query.matches;

		// (B) 綁定 'change' 監聽器
		//     當狀態改變時，呼叫我們的通用函式
		query.addEventListener('change', function (event) {
			handleBreakpointChange(event, key);

			if (key === 'isDesktop') {
				if (event.matches) {
					// 進入桌機
					destroyMobileMenu();
				} else {
					// 進入手機
					initMobileMenuIfNeeded();
					setTimeout(syncGoogleTranslateLanguage, 300);
				}
			}
		});
	});
	// ===================

	// 電腦版nav下拉選單
	const navDropDown = $('.navigation-menu .navigation-menu-item ul.navigation-menu-second-layer');
	changeNavDropdown(navDropDown);
	// ==================

	// 手機版選單
	if (!viewState.isDesktop) {
		// 1. 設定與模板
		const CONFIG = {
			urls: {
				home: '/',
				products: '/pages/products',
				images: {
					slogan: 'https://gdlinode.tw/kapla/images/footer-slogan.svg',
					ig: 'https://gdlinode.tw/kapla/images/footer-ig.svg',
					fb: 'https://gdlinode.tw/kapla/images/footer-fb.svg',
					arrow: 'https://gdlinode.tw/kapla/images/footer-arrow.svg'
				}
			},
			selectors: {
				menuPanel: '#MenuPanel',
				mainMenu: 'ul.MenuPanel-mainMenu',
				categoryMenu: '.MenuPanel-categoryMenu',
				modalMask: '.sl-modal-mask'
			}
		};
		const TEMPLATES = {
			closeBtn: `
            <div class="menu-closed-box">
                <div class="menu-closed-item"></div>
            </div>`,
			homeLink: `
            <li class="List-item MenuPanel-nestedList sl-dropdown ng-isolate-scope is-collapsed">
                <a class="Label" href="${CONFIG.urls.home}">首頁</a>
            </li>`,
			menuBottom: `
            <div class="menu-bottom">
                <div class="slogan"><img src="${CONFIG.urls.images.slogan}"></div>
                <div class="follow-items">
                    <div class="title">Follow Us</div>
                    <nav class="flex">
                        <a href="https://www.instagram.com/kaplataiwan/" class="basic-hover" target="_blank"><img src="${CONFIG.urls.images.ig}"></a>
                        <a href="https://www.facebook.com/kaplaFAPglobal/?locale=zh_TW" class="basic-hover" target="_blank"><img src="${CONFIG.urls.images.fb}"></a>
                    </nav>
                </div>
            </div>`,
			hoverIcon: `
            <div class="menu-hover-icon"><img src="${CONFIG.urls.images.arrow}"></div>`,
			backBtn: `
            <li class="List-item menu-back-btn"><img src="${CONFIG.urls.images.arrow}">Products</li>`,
			seriesOverview: `
            <li class="List-item">
                <a class="Label" link-highlight="${CONFIG.urls.products}" href="${CONFIG.urls.products}">系列總覽</a>
            </li>`
		};

		let mobileMenuInitialized = false;

		// 重構手機版介面
		function initMobileUI() {
			const $menuPanel = $(CONFIG.selectors.menuPanel);
			if (!$menuPanel.length) return;
			// 插 DOM
			buildMobileMenuUI($menuPanel);
			// 結構
			setupCategoryMenuUI($menuPanel);
			normalizeCategoryMenu($menuPanel);
			// 互動
			bindMobileMenuEvents($menuPanel);
			// 狀態
			updateMenuActiveState($menuPanel);
		};
		// 重整手機版UI
		function buildMobileMenuUI($menuPanel) {
			const $mainMenu = $(CONFIG.selectors.mainMenu);
			const $userReminder = $('user-reminder-mobile.ng-isolate-scope');

			if ($mainMenu.length && $userReminder.length) {
				$userReminder.after(TEMPLATES.homeLink);
			}

			$menuPanel.prepend(TEMPLATES.closeBtn);
			$menuPanel.append(TEMPLATES.menuBottom);

			// hover icon（防重複）
			$menuPanel.find('a.Label').each(function () {
				const $link = $(this);
				if (!$link.find('.menu-hover-icon').length) {
					$link.append(TEMPLATES.hoverIcon);
				}
			});
		}
		// 連結高亮
		function handleLinkActiveState($container) {

			const $links = $container.find('a.Label');
			if (!$links.length) return;

			// 使用既有全域 pathname（只在這裡標準化）
			const currentPath = decodeURIComponent(pathname).replace(/\/+$/, '') || '/';

			$links.removeClass('active');

			$links.each(function () {
				const $link = $(this);
				let href = $link.attr('href');
				if (!href || href === '#') return;

				// 確認網站連結
				const isAbsolute = /^https?:\/\//.test(href);
				const isSameOrigin = href.startsWith(window.location.origin);
				if (isAbsolute && !isSameOrigin) return;
				// ==========

				let linkPathRaw;
				if (isAbsolute) {
					linkPathRaw = new URL(href).pathname;
				} else {
					// 處理相對路徑，確保開頭有 /
					let tempPath = href.split('?')[0];
					if (!tempPath.startsWith('/')) {
						tempPath = '/' + tempPath;
					}
					linkPathRaw = tempPath;
				}

				// 標準化 link path
				const linkPath = isAbsolute
					? new URL(href).pathname.replace(/\/+$/, '') || '/'
					: href.split('?')[0].replace(/\/+$/, '') || '/';

				// ① 首頁（只能自己亮）
				if (currentPath === '/' && linkPath === '/') {
					$link.addClass('active');
					return;
				}

				// ② pages 頁面精準比對
				if (currentPath === linkPath && linkPath !== '/') {
					$link.addClass('active');
					return;
				}

				// ③ products / categories → 強制亮 Products
				if (
					(currentPath.startsWith('/pages/products') ||
						currentPath.startsWith('/categories')) &&
					linkPath === '/pages/products'
				) {
					$link.addClass('active');
				}
			});
		}
		// 重構商品頁選單
		function setupCategoryMenuUI($menuPanel) {
			const $categoryMenu = $menuPanel.find(CONFIG.selectors.categoryMenu);
			if (!$categoryMenu.length) return;

			// 移除 精選商品
			$categoryMenu.find('a[href*="/categories/featured-products"]').closest('li').remove();

			// 插入 返回 與 系列總覽（防重複）
			if (!$categoryMenu.find('li.menu-back-btn').length) {
				$categoryMenu.prepend(TEMPLATES.seriesOverview);
				$categoryMenu.prepend(TEMPLATES.backBtn);
			}

			// 返回鍵
			$categoryMenu.find('li.menu-back-btn').off('click').on('click', function () {
				const $sidrPanel = $(this).closest('.sidr');
				if ($sidrPanel.length) {
					const $categoryHeader = $sidrPanel.find('.MenuPanel-section-header:contains("分類")');
					const $menuInner = $sidrPanel.find(CONFIG.selectors.categoryMenu);

					$menuInner.toggleClass('show-menu');
					if ($categoryHeader.length) $categoryHeader.toggleClass('show-menu');
				}
			});
		}
		function normalizeCategoryMenu($menuPanel) {
			const $categoryMenu = $menuPanel.find(CONFIG.selectors.categoryMenu);
			if (!$categoryMenu.length || $categoryMenu.data('normalized')) return;

			$categoryMenu.children('li.MenuPanel-nestedList').each(function () {
				const $parentLi = $(this);
				const $subMenu = $parentLi.children('ul.MenuPanel-nestedList-dropdown');

				// 只處理有子選單的項目
				if (!$subMenu.length) return;

				const $subItems = $subMenu.children('li').clone(true);

				// 原地插入，維持排序
				$parentLi.after($subItems);

				// 移除外層分類
				$parentLi.remove();
			});

			$categoryMenu.data('normalized', true);
		}
		// 綁定手機選單事件
		function bindMobileMenuEvents($menuPanel) {

			// 關閉
			$menuPanel.find('.menu-closed-box').on('click', function (e) {
				e.preventDefault();
				$(CONFIG.selectors.modalMask).trigger('click');
			});

			// Products（標準版行為）
			$('body').on('click', '.sidr .MenuPanel-mainMenu a[href*="/products"]', function (e) {
				const $link = $(this);

				// 修正 href 防止錯誤跳轉（你原本的設計）
				if ($link.attr('href') !== CONFIG.urls.products && $link.attr('href') !== '#') {
					$link.attr('href', CONFIG.urls.products);
				}

				e.stopImmediatePropagation();
				e.preventDefault();

				const $sidrPanel = $link.closest('.sidr');
				if ($sidrPanel.length) {
					const $categoryHeader = $sidrPanel.find('.MenuPanel-section-header:contains("分類")');
					const $menuInner = $sidrPanel.find(CONFIG.selectors.categoryMenu);

					$menuInner.toggleClass('show-menu');
					if ($categoryHeader.length) $categoryHeader.toggleClass('show-menu');
				}

				// 同步 active
				updateMenuActiveState($menuPanel);
			});
		}
		// 狀態同步
		function updateMenuActiveState($menuPanel) {
			handleLinkActiveState($menuPanel);

			// Shopline menu 非同步補保險
			setTimeout(() => {
				handleLinkActiveState($menuPanel);
			}, 300);
		}
		// 移除手機板選單(切換到電腦版時)
		function destroyMobileMenu() {
			const $menu = $(CONFIG.selectors.menuPanel);

			if (!$menu.length) return;

			$menu.find('.menu-closed-box').remove();
			$menu.find('.menu-bottom').remove();
			$menu.find('.menu-hover-icon').remove();

			$menu.removeClass('mobile-initialized show-menu');
			mobileMenuInitialized = false;
		}

		// 集中使用控制器控制
		function initMobileMenuIfNeeded() {
			if (viewState.isDesktop) return;
			if (mobileMenuInitialized) return;

			initMobileUI();
			mobileMenuInitialized = true;
		}


		initMobileMenuIfNeeded()
	}


	// Google 翻譯與全站語系記憶修復 (Cookie Fix)
	// ==========================================

	// 定義強制的 Cookie 寫入函式，強制將 Cookie 寫入根目錄，並鎖定網域(解決跳頁失效)
	const forceSetGoogleCookie = function (lang) {
		const maxAge = 2592000; // 30天
		let cookieValue = '/zh-TW/zh-TW';

		if (lang && lang !== 'zh-TW') {
			cookieValue = `/zh-TW/${lang}`;
		}

		const domain = window.location.hostname;
		document.cookie = `googtrans=${cookieValue}; path=/; max-age=${maxAge}`;
		document.cookie = `googtrans=${cookieValue}; path=/; domain=${domain}; max-age=${maxAge}`;
	};

	// 執行翻譯動作
	window.goTranslate = function (lang) {
		const $combo = $('.goog-te-combo');
		if ($combo.length) {
			$combo.val(lang);
			document.querySelector('.goog-te-combo').dispatchEvent(new Event('change'));
		}

		forceSetGoogleCookie(lang);
		updateToggleButtonText(lang);
	};

	// 按鈕點擊切換邏輯
	window.toggleLanguage = function () {
		const currentLang = getCurrentTranslateLang();
		if (currentLang === 'en') {
			window.goTranslate('zh-TW');
		} else {
			window.goTranslate('en');
		}
	};

	// 2. 更新按鈕文字 (UI)
	const updateToggleButtonText = function (targetLang) {
		const $btn = $('#custom-lang-btn');
		if ($btn.length) {
			// 邏輯：當前是英文(en) -> 顯示 '中' (提示切回中文)
			// 邏輯：當前是中文(zh-TW) -> 顯示 'EN' (提示切換英文)
			if (targetLang === 'en') {
				$btn.text('中');
			} else {
				$btn.text('EN');
			}
		}
	};

	// 初始化 Google 翻譯元件
	let googleTranslateInitialized = false;
	const initGoogleTranslateWidget = function () {
		if (googleTranslateInitialized) return;

		const TRANS_CONFIG = {
			selectors: {
				desktop: '.header.header--desktop .header__menu',
				mobile: '#MenuPanel',
				elementId: 'google_translate_element'
			},
			script: '//translate.google.com/translate_a/element.js?cb=googleTranslateElementInit'
		};

		const $targetContainer = (viewState.isDesktop)
			? $(TRANS_CONFIG.selectors.desktop)
			: $(TRANS_CONFIG.selectors.mobile);

		if (!$targetContainer.length) return;

		if ($('#' + TRANS_CONFIG.selectors.elementId).length) {
			googleTranslateInitialized = true;
			return;
		}

		if ($targetContainer.length && !$('#' + TRANS_CONFIG.selectors.elementId).length) {

			// [關鍵修正] 在生成 HTML 前，先判斷當前語言，決定初始文字
			const currentLang = getCurrentTranslateLang();
			const initialBtnText = (currentLang === 'en') ? '中' : 'EN';

			const translateHTML = `
                <div class="google-translate">
                    <div id="${TRANS_CONFIG.selectors.elementId}" style="display:none;"></div>
                    
                    <button id="custom-lang-btn" 
                            onclick="toggleLanguage()" 
                            class="lang-toggle-btn notranslate" 
                            translate="no"
                            style="cursor: pointer; display: inline-block; padding: 0 10px;">
                        ${initialBtnText}
                    </button>
                </div>`;

			$targetContainer.children().first().after(translateHTML);
			$.getScript(TRANS_CONFIG.script);
			googleTranslateInitialized = true;
		}
	};

	// [頁面載入時] 檢查並維持語言狀態
	const getCurrentTranslateLang = function () {
		// Google Cookie 格式通常為: googtrans=/zh-TW/en
		// 我們使用正則表達式抓取最後一段 (目標語言)
		const match = document.cookie.match(/(?:^|; )googtrans=\/([^/]+)\/([^;]*)/);

		if (match && match[2]) {
			return match[2].trim();
		}
		return 'zh-TW'; // 預設回傳中文
	};

	// 執行邏輯
	initGoogleTranslateWidget();
	// 同步翻譯
	setTimeout(syncGoogleTranslateLanguage, 300);
	runPageSpecificLogic();


	function runPageSpecificLogic() {
		const path = pathname; // 你已有全域 pathname
		// 商品查詢頁
		if (path == '/pages/products' && search.includes('query=')) {
			initProductSearch();
		}
		// 商品總覽
		else if (path == '/products') {
			initProductPages();
		}
		// 商品第一頁
		else if (path == '/pages/products') {
			initProductsPages();
		}
		// 商品分類(categories)頁面
		else if (pathname.startsWith('/categories/')) {
			initCategoriesPages();
		}
		// Q&A (FAQ)
		if (path == '/pages/faqs') {
			initFaqPage();
		}
		// 會員登入
		if (path.includes('sign_in') || path.includes('sign_up')) {
			initAccountPages();
		}
		// 會員介面 - 網店購物金
		if (path == '/user_credits') {
			initAccountCredits();
		}
		// 首頁
		if (path == '/' || path.startsWith('/pages/home')) {
			initHomePage();
		}

	}

	// 檢查狀態
	maintainLanguageState();

	// 頁面 functions 

	// 會員登入
	function initAccountPages() {
		// 蓋掉原本的設定用
		$('.page-inner').addClass('btn-editer');
	}
	function initAccountCredits() {
		$('button.emotion-css-cache-jieugz a').attr('href', 'pages/products');
	}
	// 商品查詢頁
	function initProductSearch() {
		//取得查詢參數
		function getQueryParam(paramName) {
			// 使用 URLSearchParams API 解析查詢字串
			const params = new URLSearchParams(search);

			// 取得查詢參數的值
			const value = params.get(paramName);
			return value; // 回傳字串；找不到 => null
		}
		// ========

		// 移除精選分類
		removeFeaturedProducts();

		// 顯示查詢的文字
		const searchKeyword = getQueryParam('query');
		if (searchKeyword) {
			$('h1.Label').text(`搜尋: ${searchKeyword}`);
		}
	};
	// 商品總覽
	function initProductPages() {
		// 移除精選分類
		removeFeaturedProducts();
		$('.ProductList-categoryMenu.is-collapsed.is-mobile-collapsed').prepend(`<li class="List-item second-layer-content all-category-link">
                <a class="Label primary-color-hover is-active-current" href="${pathname}">
                    All
                </a>
            </li>`)
	}
	// 商品第一頁
	function initProductsPages() {
		// 新增木棒跟小icon
		$("#Content .CustomPage").addClass("products-bg");
		$(".image-with-text__container").addClass("products-items");


		// 拿掉會晃的小棍子
		// if (viewState.isLaptop || viewState.isDesktop) {
		// 	var _item_banner =
		// 		'<ul class="products-sticks flex space-x-[40px] justify-center">' +
		// 		'<li><img src="https://gdlinode.tw/kapla/images/products-stick.png"></li>' +
		// 		'<li><img src="https://gdlinode.tw/kapla/images/products-stick.png"></li>' +
		// 		'<li><img src="https://gdlinode.tw/kapla/images/products-stick.png"></li>' +
		// 		'<li><img src="https://gdlinode.tw/kapla/images/products-stick.png"></li>' +
		// 		'<li><img src="https://gdlinode.tw/kapla/images/products-stick.png"></li>' +
		// 		'<li><img src="https://gdlinode.tw/kapla/images/products-stick.png"></li>' +
		// 		'<li><img src="https://gdlinode.tw/kapla/images/products-stick.png"></li>' +
		// 		"</ul>" +
		// 		'<div class="products-roll-items">' +
		// 		'<div class=""><img src="https://gdlinode.tw/kapla/images/products-roll.png"></div>' +
		// 		'<div class="absolute tf w-full text-center"><img src="https://gdlinode.tw/kapla/images/products-roll-text.svg" class="inline-block animate-spin-slow"></div>' +
		// 		'<div class="tower"><img src="https://gdlinode.tw/kapla/images/tower.png"></div>' +
		// 		"</div>";
		// } else {
		// 	var _item_banner =
		// 		'<ul class="products-sticks flex space-x-[40px] justify-center">' +
		// 		'<li><img src="https://gdlinode.tw/kapla/images/products-stick.png"></li>' +
		// 		'<li><img src="https://gdlinode.tw/kapla/images/products-stick.png"></li>' +
		// 		'<li><img src="https://gdlinode.tw/kapla/images/products-stick.png"></li>' +
		// 		'<li><img src="https://gdlinode.tw/kapla/images/products-stick.png"></li>' +
		// 		"</ul>";
		// }
		// $("#Content .CustomPage .shopline-section").eq(0).append(_item_banner);



		// 商品分類新增小圖
		var _item1 =
			'<div class="deco">' +
			'<img src="https://gdlinode.tw/kapla/images/products-cat-pic-1.png">' +
			"</div>";
		$("#Content .CustomPage .shopline-section").eq(1).addClass("setbg");
		// $("#Content .CustomPage .shopline-section").eq(0).addClass("borderRadius");
		$("#Content .CustomPage .shopline-section").eq(1).find(".image-with-text__image-container")
			.append(_item1);
		// $("#Content .CustomPage .shopline-section")
		//   .eq(1)
		//   .find(".text-block__title")
		//   .append(
		//     '<div class="deco"><img src="https://gdlinode.tw/kapla/images/products-deco-yellow.png"></div>'
		//   );

		var _item2 =
			'<div class="deco right">' +
			'<img src="https://gdlinode.tw/kapla/images/products-cat-pic-2.png">' +
			"</div>";
		$("#Content .CustomPage .shopline-section").eq(2).addClass("setbg");
		$("#Content .CustomPage .shopline-section").eq(2)
			.find(".image-with-text__image-container")
			.append(_item2);
		$("#Content .CustomPage .shopline-section").eq(2)
			.find(".image-with-text__image-container")
			.addClass("right");
		// $("#Content .CustomPage .shopline-section")
		//   .eq(2)
		//   .find(".text-block__title")
		//   .append(
		//     '<div class="deco"><img src="https://gdlinode.tw/kapla/images/products-deco-red.png"></div>'
		//   );
		$("#Content .CustomPage .shopline-section")
			.eq(1)
			.find(".text-block__item")
			.addClass("hundred");

		var _item3 =
			'<div class="deco">' +
			'<img src="https://gdlinode.tw/kapla/images/products-cat-pic-3.png">' +
			"</div>";
		$("#Content .CustomPage .shopline-section").eq(3).addClass("setbg");
		$("#Content .CustomPage .shopline-section")
			.eq(3)
			.find(".image-with-text__image-container")
			.append(_item3);
		// $("#Content .CustomPage .shopline-section")
		//   .eq(3)
		//   .find(".text-block__title")
		//   .append(
		//     '<div class="deco"><img src="https://gdlinode.tw/kapla/images/products-deco-yellow.png"></div>'
		//   );
		$("#Content .CustomPage .shopline-section")
			.eq(3)
			.find(".text-block__title")
			.addClass("two");

		var _item4 =
			'<div class="deco right">' +
			'<img src="https://gdlinode.tw/kapla/images/products-cat-pic-4.png">' +
			"</div>";
		$("#Content .CustomPage .shopline-section").eq(4).addClass("setbg");
		$("#Content .CustomPage .shopline-section")
			.eq(4)
			.find(".image-with-text__image-container")
			.append(_item4);
		$("#Content .CustomPage .shopline-section")
			.eq(4)
			.find(".image-with-text__image-container")
			.addClass("right");
		// $("#Content .CustomPage .shopline-section")
		//   .eq(4)
		//   .find(".text-block__title")
		//   .append(
		//     '<div class="deco"><img src="https://gdlinode.tw/kapla/images/products-deco-red.png"></div>'
		//   );
		$("#Content .CustomPage .shopline-section")
			.eq(4)
			.find(".text-block__title")
			.addClass("two");

		var _item5 =
			'<div class="deco">' +
			'<img src="https://gdlinode.tw/kapla/images/products-cat-pic-5.png">' +
			"</div>";
		$("#Content .CustomPage .shopline-section").eq(5).addClass("setbg");
		$("#Content .CustomPage .shopline-section")
			.eq(5)
			.find(".image-with-text__image-container")
			.append(_item5);
		// $("#Content .CustomPage .shopline-section")
		//   .eq(5)
		//   .find(".text-block__title")
		//   .append(
		//     '<div class="deco"><img src="https://gdlinode.tw/kapla/images/products-deco-yellow.png"></div>'
		//   );
		$("#Content .CustomPage .shopline-section")
			.eq(5)
			.find(".text-block__title")
			.addClass("two");

		$(".text-block__button").each(function () {
			var $this = $(this);
			var text = $this.text();
			if (text.includes("more")) {
				var updatedText = text.replace(
					"more", 'more'
					// 'more<span class="arrow"><img src="https://gdlinode.tw/kapla/images/products-arrow.svg"></span>'
				);
				$this.html(updatedText);
			}
		});

		$("#Content .CustomPage .shopline-section").addClass("relative");


		// 先移除動畫
		// $('.products-items').each(function (i, el) {
		// 	ScrollTrigger.create({
		// 		toggleActions: "play pause resume reverse", //重覆觸發
		// 		trigger: el,
		// 		start: "top 60%",
		// 		end: "bottom 60%",
		// 		// markers: true,
		// 		onEnter() {
		// 			$(el).addClass('is-show')
		// 		},
		// 	});
		// });
	};
	// 商品分類(categories)頁面
	function initCategoriesPages() {
		// 移除精選分類
		removeFeaturedProducts();


		// 修改有下拉選單的商品分類
		// 依據 H1 標題重構分類選單
		const $categoryMenu = $('.ProductList-categoryMenu');
		const pageTitle = $('h1.Label').text().trim();
		const activeClass = 'is-active-current'; // 標記當前頁面
		let $matchingParentLi = null; // 儲存匹配到的第一層 <li>
		let matchType = null;         // 匹配類型

		if (pageTitle && $categoryMenu.length) {

			// 尋找匹配項，並確定 matchType
			$('.ProductList-categoryMenu > li.List-item').each(function () {
				const $li = $(this);
				const $firstLink = $li.children('a.Label').first();
				const hasSubMenu = $li.find('.ProductList-nestedList-dropdown').length > 0;

				const firstLevelText = $firstLink.text().trim();

				// 檢查是否匹配第一層標題
				if (firstLevelText === pageTitle) {
					$matchingParentLi = $li;
					if (hasSubMenu) {
						matchType = 'first_with_sub';
					} else {
						matchType = 'first_no_sub';
					}
					return false;
				}

				// 檢查是否匹配子分類標題 (第二層)
				const $matchingSubLink = $li.find('.ProductList-nestedList-dropdown a.Label').filter(function () {
					return $(this).text().trim() === pageTitle;
				});

				if ($matchingSubLink.length > 0) {
					$matchingParentLi = $li;
					matchType = 'sub_level';
					return false;
				}
			});


			// 根據 matchType 執行重構邏輯
			// 沒有子選單 => 隱藏所有選單
			if (matchType === 'first_no_sub') {
				$categoryMenu.hide();
			}

			// 重構選單 => 將子選單移出取代主選單
			if (matchType === 'first_with_sub' || matchType === 'sub_level') {

				const $subMenuUl = $matchingParentLi.children('.ProductList-nestedList-dropdown');
				const $parentCategoryLink = $matchingParentLi.children('a.Label').first();
				const parentHref = $parentCategoryLink.attr('href');

				// 移除並替換選單
				// 複製子選單項目 (<li>)
				const $nestedLis = $subMenuUl.children('li.List-item').clone(true);

				// 清空整個主選單 <ul>
				$categoryMenu.empty();

				// 將子選單項目附加到主選單 <ul>
				$categoryMenu.append($nestedLis);

				// ** 執行 b-1 & b-3/c: 新增 "All" 並設定 .active
				const $allLi = $(`
            <li class="List-item second-layer-content all-category-link">
                <a class="Label primary-color-hover" href="${parentHref}">
                    All
                </a>
            </li>
        `);

				// 判斷哪個項目應該是 active
				if (matchType === 'first_with_sub') {
					// 匹配到第一層標題時，"All" 應為 active
					$allLi.children('a').addClass(activeClass);
				} else if (matchType === 'sub_level') {

					// 連結是到子分類標題時，對應的 <li> 設定 active
					$categoryMenu.children('li.List-item').each(function () {
						const $li = $(this);
						if ($li.children('a.Label').first().text().trim() === pageTitle) {
							$li.children('a.Label').addClass(activeClass);
							return false;
						}
					});
				}

				// 將 "All" 連結插入到重構後選單的最前面
				$categoryMenu.prepend($allLi);
			}

			// [注意] 由於選單已被替換，原有的點擊/收合邏輯可能需要重新綁定，
		}
		// ====================================================

		$('.ProductList-container').prepend(`
          <div class="productDetail-banner">
        <div class="title">${pageTitle}</div>
        <div class="pic-area">
            <div class="deco">
                <img src="https://gdlinode.tw/kapla/images/pd-banner-deco.png" alt="">
                <div class="circle"><img src="https://gdlinode.tw/kapla/images/pd-circle.svg" alt=""></div>
            </div>
            <div class="pic">
                <img src="https://gdlinode.tw/kapla/images/pd-banner.png" alt="">
            </div>
        </div>
    </div>
      `)
		$('#Content').css('background-color', '#FBF7EB')

		// $('.Product-item .Product-info').each(function (i, el) {
		// 	$(el).append(`<div class="customized-btn buy-btn">Add to cart</div>`);
		// });

		// 修改原生加入購物車
		$('.btn-add-to-cart.js-btn-add-to-cart.mobile-cart.visible-xs.visible-sm').addClass('category-add-btn').removeClass('mobile-cart visible-xs visible-sm').html(`<div class="customized-btn buy-btn">Add to cart</div>`);
	};
	// Q&A (FAQ)
	function initFaqPage() {
		const fiveDivsHtml = `
    <div class="custom-qa-item qa-title-img custom-qa-1"><img src="https://gdlinode.tw/kapla/images/qa-title-img-1.png" alt=""></div>
    <div class="custom-qa-item qa-title-img custom-qa-2"><img src="https://gdlinode.tw/kapla/images/qa-title-img-2.png" alt=""></div>
    <div class="custom-qa-item custom-qa-title">FAQs</div>
    <div class="custom-qa-item qa-title-img custom-qa-3"><img src="https://gdlinode.tw/kapla/images/qa-title-img-3.png" alt=""></div>
    <div class="custom-qa-item qa-title-img custom-qa-4"><img src="https://gdlinode.tw/kapla/images/qa-title-img-4.png" alt=""></div>
`;
		// 取消生成
		// $('.accordion__title').html(fiveDivsHtml)


		// const $targetH3 = $('h3.accordion__title');

		// if ($targetH3) {
		//   $targetH3.after(fiveDivsHtml);
		//   console.log('isActive');
		// };


		$('.accordion-widget').addClass('faqWrap')
		// $(".accordion-item.accordion-item--clickable").each(function (i, el) {
		// 	var num = i + 1;
		// 取消標題的積木棍
		// $(el).prepend(`
		// 	<div class="qa-deco"><img src="https://gdlinode.tw/kapla/images/qa-title-deco.png"></div>
		// 	<div class="qa-number">Q${num}</div>
		// 	`);
		//生成數字
		// 	$(el).prepend(`
		// 		<div class="qa-number">Q${num}</div>
		// 		`);
		// });
	}
	//首頁
	function initHomePage() {
		// 價格改成顯示 more
		$('#shopline-section-174824752054540f731a .quick-cart-price').each(function (i, el) {
			// $(el).html(`<img src="https://gdlinode.tw/kapla/images/index-product-more.svg">`);

			$addBtnBox = `<div class="btn-box">${$customMoreBtn}<div>`
			$(el).after($addBtnBox);
		});

		// 新增加入購物車按鈕
		// if ($('#shopline-section-174824752054540f731a')) {
		// 	const products = document.querySelectorAll("a.quick-cart-item");

		// 	products.forEach(product => {

		// 		// 1. 找 info-box-inner-wrapper
		// 		const infoBox = product.querySelector(".info-box-inner-wrapper");
		// 		if (!infoBox) return;

		// 		// 找到原本的 add-to-cart 按鈕（用於複製相同功能）
		// 		const infoBoxBtn = infoBox.querySelector(".btn-add-to-cart.js-btn-add-to-cart.mobile-cart.visible-xs.visible-sm");
		// 		if (!infoBoxBtn) return;

		// 		// 複製按鈕
		// 		// const newBtn = originalBtn.cloneNode(true);

		// 		// 調整class
		// 		infoBoxBtn.classList.remove("mobile-cart", "visible-xs", "visible-sm");
		// 		infoBoxBtn.style.cursor = "pointer";
		// 		infoBoxBtn.innerHTML = `add to cart`;

		// 		// infoBox.appendChild(newBtn);
		// 	});
		// };

		// 商品旁的箭頭
		if (viewState.isDesktop || viewState.isLaptop) {
			$('#shopline-section-174824752054540f731a .owl-prev').html(`<img src="https://gdlinode.tw/kapla/images/index-product-prev.svg">`)
			$('#shopline-section-174824752054540f731a .owl-next').html(`<img src="https://gdlinode.tw/kapla/images/index-product-next.svg">`)
		} else {
			$('#shopline-section-174824752054540f731a .owl-prev').html(`<img src="https://gdlinode.tw/kapla/images/index-product-prev-mobile.svg">`)
			$('#shopline-section-174824752054540f731a .owl-next').html(`<img src="https://gdlinode.tw/kapla/images/index-product-next-mobile.svg">`)
		}

		// 首頁news list more
		$('#shopline-section-17508303624056c04d49 .text-block__button').each(function (i, el) {
			// $(el).html(`<img src="https://gdlinode.tw/kapla/images/index-news-more.svg">`);
			$(el).html($customLearnMoreBtn);
		});

		// 首頁new下方more
		$('#shopline-section-17508303624056c04d49 .section-width').append(`<div class="big-more-btn"><a href="https://www.facebook.com/kaplaFAPglobal?locale=zh_TW" target="_blank">${$customMoreBtn}</a></div>`);

		// 生成箭頭
		// 電腦版or手機版
		const mediaQuery = window.matchMedia('(min-width: 601px)');
		let isDesktop = mediaQuery.matches;


		// 彈跳視窗
		initPopUp();
		function initPopUp() {
			const $popup = $('#shopline-section-1772787217037ee25d89');
			if ($popup.length === 0) return;

			const closeBtn = `<div class="close-btn"><img src="https://gdlinode.tw/kapla/images/closeBtn.png"></div>`;
			$popup.append(closeBtn);

			// 有沒有內容
			const $popImgB = $popup.find('.image-with-text__image-container');
			const $noImg = $popImgB.find('svg').length > 0;
			const $noTextBox = $popup.find('.text-block__item').text().trim() === '';
			const $notitle = $popup.find('h3.text-block__title').text().trim() === '';
			const $nosubtitle = $popup.find('h4.text-block__subtitle').text().trim() === '';
			const $noIInfo = $popup.find('.text-block__content').text().trim() === '';

			// $popup.attr('style', 'display:none');
			if ($noTextBox && $noImg) {
				console.log('沒圖片', $noImg);
				console.log('沒文字', $noTextBox);

				return;
			} else {
				$popup.delay(700).fadeIn(500);
				$('body').addClass('popup-open');
			}

			// 沒圖片
			if ($noImg) {
				$popImgB.attr('style', 'display:none');
			}
			// 沒標題
			if ($notitle) {
				$popup.find('h3.text-block__title').attr('style', 'display:none');
			}
			// 沒副標題
			if ($nosubtitle) {
				$popup.find('h4.text-block__subtitle').attr('style', 'display:none');
			}
			// 沒內文
			if ($noIInfo) {
				$popup.find('.text-block__content').attr('style', 'display:none');
			}
			// =====

			const $mask = $('<div class="popup-mask"></div>');
			$popup.prepend($mask);

			// 關閉
			$mask.on('click', function () {
				$('body').removeClass('popup-open');
				$popup.fadeOut(500);
			});
			$popup.find('.close-btn').on('click', function () {
				$('body').removeClass('popup-open');
				$popup.fadeOut(500);
			});
			// ===
		}
	}
	// ====
};
